import { render, staticRenderFns } from "./body.vue?vue&type=template&id=b2f8ff24&scoped=true"
import script from "./body.vue?vue&type=script&lang=js"
export * from "./body.vue?vue&type=script&lang=js"
import style0 from "./body.vue?vue&type=style&index=0&id=b2f8ff24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f8ff24",
  null
  
)

export default component.exports